import MetricBase from "models/metrics/MetricBase";
import PerformanceGroup from "models/groups/PerformanceGroup";
import i18n from "i18next";
import PercentUnit from "../../../unit/PercentUnit";

class MetricCsr extends MetricBase {
    constructor() {
        super({
            field: "metric_csr",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.kayak.csr.chartName"),
            serieLabel: i18n.t("metrics.kayak.csr.serieLabel"),
            tooltip: i18n.t("metrics.kayak.csr.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricCsr;
